import { connect } from 'react-redux';

import Article from 'models/Article';
import ArticleCategory from 'models/ArticleCategory';
import Visitor from 'models/Visitor';

import { State } from 'store/state';

import Component from './component';

export interface Props extends ParentProps {
    state: {
        visitor: Visitor;
    }
}

export interface LocalRatings {
    rating: number;
    id: string;
}

export interface ParentProps {
    article: Article;
    articleCategories: ArticleCategory[];
    articleContentCopy?: {
        listHeadline?: string;
        rate?: {
            rateTitle?: string;
            ratingTitle?: string;
            ratedTitle?: string;
            ratingsCountTitle?: string;
            noRating?: string;
        },
        author?: {
            specializtionTitle?: string;
            bioTitle?: string;
        },
        socials?: {
            socialsTitle?: string;
        }
    };
}

const mapStateToProps = (state: State, ownProps?: Props): object => {
    return {
        state: {
            visitor: state?.visitor?.data,
        },
    };
};


Component.defaultProps = {};

export default connect(mapStateToProps, null)(Component);
